import Cookies from "universal-cookie";

const cookies = new Cookies();

// Same dedicated back-office RestApi used by the supplier explorer, audit and integrations.
const BASE = process.env.BACKOFFICE_SERVER_URL || "";

const backofficeFetch = async (path, { method = "GET" } = {}) => {
  const { token } = cookies.get("userId") || {};
  try {
    const res = await fetch(`${BASE}${path}`, {
      method,
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json().catch(() => null);
    if (!res.ok) return data ?? { message: "Erro ao comunicar com o servidor" };
    return data;
  } catch {
    return null;
  }
};

const httpMessage = (status) => {
  if (status === 401) return "Sessão expirada. Entre de novo para verificar as permissões.";
  if (status === 403) return "Acesso restrito a administradores.";
  if (status === 404) return "Empresa não encontrada no cadastro.";
  if (status === 429) return "Limite de requisições atingido. Aguarde e tente de novo.";
  if (status === 504 || status === 502 || status === 408) {
    return "A sondagem demorou mais que o limite do gateway. Tente de novo — a verificação continua de onde parou.";
  }
  return `Erro ${status} ao comunicar com o servidor.`;
};

// Variante que PRESERVA o desfecho. O helper acima colapsa "caiu a rede", "504 do gateway" e
// "403 de admin" em `null`/`{message}`, e a tela de permissões engolia os três em silêncio —
// ficava em "Carregando…" ou voltava de "Verificando…" sem dizer nada. Aqui todo retorno diz
// o que aconteceu, e quem chama decide o que mostrar.
const backofficeRequest = async (path, { method = "GET" } = {}) => {
  const { token } = cookies.get("userId") || {};
  let res;
  try {
    res = await fetch(`${BASE}${path}`, {
      method,
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch {
    return {
      ok: false,
      status: 0,
      data: null,
      message: "Sem conexão com o servidor do back office. Verifique a rede e tente de novo.",
    };
  }
  const data = await res.json().catch(() => null);
  if (res.ok) return { ok: true, status: res.status, data, message: null };
  return {
    ok: false,
    status: res.status,
    data,
    message: typeof data?.message === "string" && data.message.trim()
      ? data.message
      : httpMessage(res.status),
  };
};

// One row per SIENGE client with the last recorded probe (loads instantly, no Sienge call).
export const fetchSiengePermissions = () =>
  backofficeRequest(`/integrations/listSiengePermissions`);

// Probes the given client's Sienge APIs live and records the result. `group` restringe a
// sondagem a um grupo do catálogo, para caber no limite de tempo do gateway.
export const checkSiengePermissions = (companyId, group) =>
  backofficeRequest(
    `/integrations/checkSiengePermissions?company_id=${encodeURIComponent(companyId)}`
    + (group ? `&group=${encodeURIComponent(group)}` : ""),
    { method: "POST" },
  );

// Pré-requisito da tela "New Building": testa a conectividade com o ERP da construtora antes
// de liberar o envio. Retorna `{supported: false, reason}` para ERPs sem sonda implementada
// (Mega, Prevision) e `{supported: true, scopes, denied}` para Sienge.
export const testConnection = (companyId) =>
  backofficeFetch(`/integrations/testConnection?company_id=${encodeURIComponent(companyId)}`, {
    method: "POST",
  });
